module.exports = __webpack_public_path__ + "img/consult_info5.38e64038.png";